import React from 'react'
import { Navigate } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles'
import { KioskBackgroundDefault } from '@pbt/pbt-ui-components/src/icons'

import KioskWrapper from '../KioskWrapper'
import TermsAndConditionsScreen from './TermsAndConditionsScreen'

const useStyles = makeStyles(
  () => ({
    background: {
      position: 'fixed',
      zIndex: 0,
      bottom: 0,
      left: 0,
      height: 'auto',
      width: '100%',
    },
  }),
  { name: 'TermsAndConditionsWrapperScreen' },
)

const TermsAndConditionsWrapperScreen = () => {
  const redirectToMembership = () => <Navigate replace to="membership" />

  const routes = [
    { Component: TermsAndConditionsScreen, path: 'membership' },
    { Component: redirectToMembership, path: '/' },
  ]

  const classes = useStyles()

  return (
    <>
      <KioskBackgroundDefault className={classes.background} />
      <KioskWrapper hideBusinessInfo hideBusinessLogo routes={routes} />
    </>
  )
}

export default TermsAndConditionsWrapperScreen
